import React, { Component, useEffect } from "react";
import ResultsTable from "./ResultTable";
import BatchList from "./BatchList";
import Achievement from "./Achievement";
import movieTranslations from "./Lang/en.json";
import frenchMovieTranslations from "./Lang/ar.json";
import { Translate, withLocalize } from "react-localize-redux";

const Results = props => {
  useEffect(() => {
    props.addTranslationForLanguage(movieTranslations, "en");
    props.addTranslationForLanguage(frenchMovieTranslations, "ar");
  }, []);

  return (
    <div>
      <div class="card">
        <div class="card-block">
          <h4 class="card-title m-t-0">
            <Translate id="general.StudentResults" />
          </h4>
          <p class="card-text">
            View the results and the attendance of the current and previous semesters
          </p>
        </div>
      </div>
      <BatchList batchNum={props.match.params.batchNum} />

      <div class="card">
        <div class="card-block">
          <h4 class="card-title m-t-0">
             <Translate id="results.name" />
          </h4>
          <h6 className="card-subtitle m-b-10 text-muted"></h6>

          <ResultsTable batchNum={props.match.params.batchNum} />
        </div>
      </div>
      <Achievement batchNum={props.match.params.batchNum} />
    </div>
  );
};

export default withLocalize(Results);



// WEBPACK FOOTER //
// ./src/pages/results/Results.js